// ============================================================
// หน้า Logfile — ล็อกไฟล์
// ------------------------------------------------------------
// ประวัติการใช้งานระบบทั้งหมด (ใคร ทำอะไร เมนูไหน เอกสารเลขที่เท่าไหร่)
// อ่านอย่างเดียว ค้นหา (คำค้น + ช่วงวันที่) และแบ่งหน้าได้ — เห็นเฉพาะเจ้าของระบบ (ตั้งไว้ที่เมนูใน Navbar)
// ============================================================

import React, { Component } from "react";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { tokens, GET, format_date, loading, Paginate, DatePicker } from "../../shared/index.js";

const TABLE_HEADERS = ["วันที่ / เวลา", "ผู้ใช้งาน", "เมนู", "เลขที่เอกสาร", "รายการ"];

export default class Logfile extends Component {
  // search/start_date/end_date = ค่าในช่องกรอก · query = เงื่อนไขที่กดค้นหาไปแล้วจริง
  // แยกกันเพื่อให้เปลี่ยนหน้าแล้วใช้เงื่อนไขเดิมของตารางที่เห็น แม้ผู้ใช้พิมพ์ค้างไว้ในช่องแต่ยังไม่กดค้นหา
  state = { page: 1, search: "", start_date: "", end_date: "", query: { search: "", start_date: "", end_date: "" }, data: null };

  async componentDidMount() {
    loading(false);
    await this.GetAll();
  }

  GetAll = async () => {
    loading(true);
    const { search, start_date, end_date } = this.state.query;
    // วันที่ว่าง = ไม่ส่ง key ไปเลย (หลังบ้านถือว่าไม่กรอง)
    const params = { data_search: search };
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;
    const result = await GET(tokens, `v1/TH/document-manage/log/filter-search/page/${this.state.page}`, params);
    if (result?.status) this.setState({ data: result.data });
    loading(false);
  };

  // กดค้นหา: กลับหน้า 1 เสมอ · ถ้าวันเริ่มอยู่หลังวันสิ้นสุดให้สลับให้ (ค่า YYYY-MM-DD เทียบเป็นข้อความได้) แทนการค้นแล้วได้ผลว่างโดยไม่รู้สาเหตุ
  Search = () => {
    let { search, start_date, end_date } = this.state;
    if (start_date && end_date && start_date > end_date) [start_date, end_date] = [end_date, start_date];
    this.setState({ start_date, end_date, query: { search, start_date, end_date }, page: 1 }, this.GetAll);
  };

  Reset = () => {
    this.setState({ search: "", start_date: "", end_date: "", query: { search: "", start_date: "", end_date: "" }, page: 1 }, this.GetAll);
  };

  render() {
    const { data, page, search, start_date, end_date } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ตั้งค่า" page3="รหัสบัญชี" />
        <div className="body">
          <div className="p-3">
            <div className="card border-0 p-3">
              <h4 className="mb-3">
                <b>ล็อกไฟล์</b>
              </h4>

              {/* ตัวกรอง */}
              <div className="d-flex align-items-center flex-wrap mb-3">
                <input type="search" className="form-control wpx-200 bg-contain border-0 mx-1" placeholder="พิมพ์คำค้นหา..." value={search} onChange={(e) => this.setState({ search: e.target.value })} />
                <label className="mb-0 mx-1 text-nowrap">จากวันที่</label>
                <div className="wpx-150 mx-1">
                  <DatePicker className="form-control bg-contain border-0 w-100" onChange={(e) => this.setState({ start_date: e })} value={start_date} />
                </div>
                <label className="mb-0 mx-1 text-nowrap">ถึงวันที่</label>
                <div className="wpx-150 mx-1">
                  <DatePicker className="form-control bg-contain border-0 w-100" onChange={(e) => this.setState({ end_date: e })} value={end_date} />
                </div>
                <button className="btn btn-primary px-3 mx-1" onClick={this.Search}>
                  ค้นหา
                </button>
                <button className="btn btn-outline-primary px-3 mx-1" onClick={this.Reset}>
                  รีเซ็ท
                </button>
              </div>

              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr className="bg-dark-blue text-white">
                      {TABLE_HEADERS.map((h) => (
                        <th key={h} className="text-left">
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {!data?.data?.length ? (
                      <tr>
                        <td colSpan={5} className="text-center">
                          ไม่มีข้อมูล
                        </td>
                      </tr>
                    ) : (
                      data.data.map((item, i) => (
                        <tr key={i}>
                          <td>{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy hh:mm:ss") : "-"}</td>
                          <td>{item.full_name || "-"}</td>
                          <td>{item.menu || "-"}</td>
                          <td>{item.document_number || "-"}</td>
                          <td>{item.event_detail || "-"}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <Paginate className="d-flex justify-content-between px-3" showJump data={data} page={page} onChange={(value) => this.setState({ page: value }, this.GetAll)} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
